import { lazy } from 'react';
import { useRoutes } from 'react-router-dom';

// routes
import MainRoutes from './MainRoutes';
import LoginRoutes from './LoginRoutes';
import AuthenticationRoutes from './AuthenticationRoutes';
import Loadable from 'ui-component/Loadable';
import GuestRoutes from './GuestRoutes';
import PublicCertificatePage from 'views/pages/PublicCertificatePage';

const PagesLanding = Loadable(lazy(() => import('views/pages/landing')));

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
    return useRoutes([
        { path: '/', element: <PagesLanding /> },
        { path: '/cert', element: <PublicCertificatePage /> },
        GuestRoutes,
        AuthenticationRoutes,
        LoginRoutes,
        MainRoutes
    ]);
}
